module.exports = __webpack_public_path__ + "img/xzp.8bce753b.png";